module.exports = __webpack_public_path__ + "media/components/common/formParts/icons/Times-a79652a38176734ec8f1a269d28ef6e7.svg";